/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

// Inject site styles into Hubspot forms. VanillaJS so jQuery load state isn't a problem.
window.addEventListener('message', function(event){
 if ((event.data && event.data.type) && (event.data.type === 'hsFormCallback') && (event.data.eventName === 'onFormReady')) {
  var hs = document.querySelectorAll('.hs-form-iframe');
  var style = document.getElementById('holistic/css-css');

  hs.forEach(function(iframe){
    var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    var form = iframeDocument.querySelector('[data-form-id="' + event.data.id + '"]');

    if(form){
      form.appendChild(style.cloneNode(false));

      if(event.data.id === '693fde30-746e-42b5-9fb0-1d468c0921c0'){
        form.classList.add('signup-widget-form');
      }
    }
  });
 }
});

// Init animations
new WOW().init();

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // --> Implement mobile menu
        $('nav.primary').before('<i class="nav-primary-control fa fa-bars"></i>');

        $navPrimaryControl = $('.nav-primary-control');
        $navPrimaryItems = $('nav.primary .menu-primary-navigation-container');

        $navPrimaryItems.addClass('menu-primary__items menu-primary__items--hidden');

        $navPrimaryControl.on('click', function(){
          $navPrimaryItems.toggleClass('menu-primary__items--hidden');
        });


        // --> Implement smooth scrolling
        //     see: https://css-tricks.com/snippets/jquery/smooth-scrolling/
        $('a[href*="#"]:not([href="#"])').click(function(){
          if(location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

            if(target.length) {
              $('html, body').animate({
                scrollTop: target.offset().top
              }, 1000);
              return false;
            }
          }
        });

        // --> Boostrap any tabbed components
        $('.tabbed').each(function(){
          var $el = $(this);

          $el.find('.tabbed__tabs a').on('click', function(e){
            e.preventDefault();
            $(this).tab('show');
          });

          $el.find('.tabbed__tabs .active').tab('show');
        });

        // --> Load in the HubSpot signup form
        $('section.content').before($('<div class="signup-widget"></div>'));

        var $suWidget = $('.signup-widget');
        var $suWidgetControl = $('<span class="signup-widget__close">x</span>');

        if($suWidget){
          hbspt.forms.create({
            portalId: '2441653',
            formId: '693fde30-746e-42b5-9fb0-1d468c0921c0',
            css: '',

            target: '.signup-widget',

            onFormReady: function(e){
              $suWidget.append($suWidgetControl);
              $suWidgetControl = $suWidget.find('.signup-widget__close');

              $suWidgetControl.on('click', function(e){
                $suWidget.remove();
              });
            },
          });
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        var approach = $('.block--approach');

        var bounceDelay = 3000;
        var bounceDuration = 1200;

        var bounce = function(){
          approach.addClass('block--bounce');

          setTimeout(function(){
            approach.removeClass('block--bounce');
          }, bounceDuration);
        };

        setTimeout(function(){
          bounce();
          setInterval(bounce, bounceDelay + bounceDuration);
        }, bounceDelay);
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
